/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React, { useContext, useState, useEffect, useMemo } from 'react'
import { strCol, intCol } from '@integec/grid-tools/lib/cols'
import { hasAccesPermits, rowHeaderRender } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import { utilityHeader, unitIdHeader } from 'core/HeaderColTypeProps'
import {
  getApiTargetInfo,
  getUtilityNameMap,
  getUnitNameMap,
  UnitSelection,
} from 'core'
import { connect } from 'react-redux'
import R from 'ramda'
import moment from 'moment'

import {
  UnitSelectionContext,
  DatePickerContext,
  SpinContext,
  ErrorContext,
} from 'context'
import {
  getNercErrors,
  getNercGroup,
  getSystemConfigurationInfo,
  nercExportFileNew,
} from 'api/pgads.js'

import { message, Button, Input, Switch, Radio, Select } from 'antd'
import { getPermitActions, getEnvConfig, getUnits } from 'core/selectors'
import Grid, { virtualizedGridRenderer } from '@integec/grid-tools'
import {
  CriteriaRow,
  Title,
  Content,
  FullHeightSizer,
  Filler,
} from 'core/screen-util'

const header = [
  utilityHeader,
  unitIdHeader,
  intCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isFiltered: true,
  }),
  intCol({
    ident: 'errorCode',
    display: 'Error Code',
  }),
  strCol({
    ident: 'error',
    display: 'Error',
    width: 550,
  }),
]
// const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const NercFileCreationAntd = ({
  apiTargetInfo,
  utility,
  unitNameMap,
  actionPermits,
  envConfig,
  units,
}) => {
  const { selectedUnits, setVisibleUnitSelection } = useContext(
    UnitSelectionContext
  )
  const { setSelectedDateRagePicker } = useContext(DatePickerContext)
  // const [loading, setLoading] = useState(false)

  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const [data, setData] = useState([])
  // const [data95, setData95] = useState([])
  // const [data97, setData97] = useState([])
  //  const [err, setError] = useState()
  const [showCreateButton, setShowCreateButton] = useState(true)
  const [startMonth, setStartMonth] = useState(0)
  const cm = useMemo(
    _ =>
      parseInt(
        moment()
          .startOf('month')
          .subtract(1, 'd')
          .format('MM')
      ) - 1,
    []
  )
  const [endMonth, setEndMonth] = useState(cm)
  const currentYear = parseInt(moment().format('YYYY'))
  const [year, setYear] = useState(currentYear)
  const [fileFormat, setFileFormat] = useState('TWO')
  const [ncEvent, setNCEvent] = useState('IN')
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [isCOPUenables, setIsCOPUEnabled] = useState(false)
  const [isCheckedCOPU, setISCheckedCOPU] = useState(false)
  const [nercGroup, setNercGroup] = useState([])
  const [criteriaStartYear, setCriteriaStartYear] = useState(currentYear - 10)
  const [criteriaEndYear, setCriteriaEndYear] = useState(currentYear + 5)
  useEffect(
    _ => {
      const end = moment([year, endMonth, 1])
        .endOf('month')
        .format('yyyy-MM-DD')
      getNercGroup(apiTargetInfo)(end).fork(setError, data => {
        setNercGroup(data)
      })
    },
    [year, endMonth, apiTargetInfo, setError]
  )

  const onCriteriaChnage = _ => {
    setSpinning(false)
  }

  const getMonth = curentMonth => {
    const id = R.indexOf(months[curentMonth], months)
    return months.map((m, i) => (
      <Select.Option key={m} value={i} disabled={i < id}>
        {m}
      </Select.Option>
    ))
  }

  useEffect(
    _ => {
      // setSelectedDate(moment([year, startMonth, 1]))
      setSelectedDateRagePicker([
        moment([year, startMonth, 1]),
        moment([year, endMonth, 1]).endOf('month'),
      ])
    },
    [startMonth, year, endMonth, setSelectedDateRagePicker]
  )

  useEffect(
    _ => {
      setIsCOPUEnabled(!!units.find(f => f.emsId === 'CO-PU'))
    },
    [units]
  )

  useEffect(() => {
    getSystemConfigurationInfo(apiTargetInfo).fork(setError, d => {
      const criteriaStartYearItem = d.find(s => s.key === 'CRITERIA_START_YEAR')
      const criteriaEndYearItem = d.find(s => s.key === 'CRITERIA_END_YEAR')
      // setState({ card97Dominant: dominantData.length > 0 ? true : false, loading: false })
      setCriteriaStartYear(
        criteriaStartYearItem
          ? parseInt(criteriaStartYearItem.value)
          : currentYear - 10
      )
      setCriteriaEndYear(
        criteriaEndYearItem
          ? parseInt(criteriaEndYearItem.value)
          : currentYear + 5
      )
    })
  }, [apiTargetInfo, currentYear, setError])

  const exportData = (blobData, type, fileName) => {
    const a = window.document.createElement('a')
    a.href = window.URL.createObjectURL(
      new Blob(blobData, { type: 'text/plain' }),
      { type }
    )
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  const exportDataWithType = (data, type) => {
    if (type === 'ALL') exportData(data, 'text/plain', 'nerc-05-07.txt')
    else
      exportData(
        data.filter(s => s.startsWith(type)),
        'text/plain',
        'nerc-' + type + '.txt'
      )
  }

  const onCreateFile = _ => {
    if (selectedUnits.length === 0) {
      message.error('Please , Selact Units')
      setVisibleUnitSelection(true)
      return
    }

    const cdata = {
      utility: selectedUnits[0].utility,
      unit: selectedUnits.map(u => u.unitId),
      year,
      fromMonth: startMonth + 1,
      toMonth: endMonth + 1,
      showEvents: ncEvent,
      sepFile: fileFormat,
      includeCOPU: isCheckedCOPU ? 'Y' : 'N',
      isCheckedCOPU: isCheckedCOPU ? 'Y' : 'N',
    }

    setSpinning(true)

    const exportFile = _ =>
      nercExportFileNew(apiTargetInfo)(cdata).fork(setError, data => {
        setData([])
        setShowCreateButton(true)
        setSpinning(false)
        if (fileFormat === 'ONE') exportDataWithType(data, 'ALL')
        else {
          exportDataWithType(data, '05')
          exportDataWithType(data, '07')
        }
      })

    showCreateButton
      ? getNercErrors(apiTargetInfo)(cdata).fork(setError, data => {
          setData(data.ERROR_DATA)
          // setData95(data.CARD95)
          // setData97(data.CARD97)
          setShowCreateButton(false)
          setSpinning(false)
          if (data.ERROR_DATA.length <= 0) {
            exportFile()
          }
        })
      : exportFile()
    // )(b => {
    //     setData([])
    //     setShowCreateButton(true)
    //     setSpinning(false)
    //   })
  }
  const headerWithFormatter = header.map(header =>
    header.ident === 'utility'
      ? {
          ...header,
          // ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) => utility[value] || value,
          sortIndexGetter: ({ rowData }) =>
            utility[rowData.utility] || rowData.utility,
        }
      : header.ident === 'unitId'
      ? {
          ...header,
          // choices: [],
          dataFormatter: ({ value }) => unitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            unitNameMap[rowData.unitId] || rowData.unitId,
        }
      : header
  )

  const hideNceventRadio = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.NERC_FILE_EXPORT_NCEVENT_RADIO_HIDE],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  return (
    <div
      style={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <UnitSelection
        setData={() => onCriteriaChnage()}
        disabled={!showCreateButton}
        nercGroup={nercGroup}
      />
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
          }}
        >
          NERC File Creation
        </Title>
        <div>
          <h3 style={{ display: 'inline', paddingRight: '20px' }}>Year</h3>
          <Select
            className="year"
            defaultValue={currentYear}
            style={{ width: 120 }}
            onChange={setYear}
            value={year}
            disabled={!showCreateButton}
          >
            {R.reverse(R.range(criteriaStartYear, criteriaEndYear + 1)).map(
              y => (
                <Select.Option value={y} key={y}>
                  {y}
                </Select.Option>
              )
            )}
          </Select>
          <h3
            style={{
              display: 'inline',
              paddingRight: '20px',
              marginLeft: '20px',
            }}
          >
            Start Month
          </h3>
          <Select
            className="startMonth"
            disabled={!showCreateButton}
            defaultValue={0}
            style={{ width: 120 }}
            onChange={setStartMonth}
            value={startMonth}
          >
            {getMonth(0)}
          </Select>
          <h3
            style={{
              display: 'inline',
              paddingRight: '20px',
              marginLeft: '20px',
            }}
          >
            End Month
          </h3>
          <Select
            className="endMonth"
            disabled={!showCreateButton}
            defaultValue={11}
            style={{ width: 120 }}
            onChange={setEndMonth}
            value={endMonth}
          >
            {getMonth(startMonth)}
          </Select>
        </div>
        <Filler />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          css={{ marginLeft: '10px', marginRight: '10px', flex: '0 0 200px' }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
        {/* <ExportComponent
            data={data}
            headers={header}
            fileName={'PJM File Creation'}
            btnStyle={{ marginRight: '10px' }}
            disabled={data.length <= 0 ? true : false}
          /> */}
      </CriteriaRow>

      <CriteriaRow
        style={{
          padding: '10px',
          marginTop: '10px',
          justifyContent: 'space-around',
        }}
      >
        {!hideNceventRadio && (
          <div>
            <h3
              style={{
                display: 'inline',
                paddingRight: '20px',
                marginLeft: '20px',
              }}
            >
              NC Event
            </h3>
            <Switch
              disabled={!showCreateButton}
              style={{ width: '100px' }}
              checkedChildren="Include"
              unCheckedChildren="Exclude"
              checked={ncEvent === 'IN'}
              onChange={checked =>
                checked ? setNCEvent('IN') : setNCEvent('EX')
              }
            />
          </div>
        )}

        {isCOPUenables && (
          <div>
            <h3
              style={{
                display: 'inline',
                paddingRight: '20px',
                marginLeft: '20px',
              }}
            >
              CO/PU Events
            </h3>
            <Switch
              disabled={!showCreateButton}
              style={{ width: '100px' }}
              checkedChildren="Include"
              unCheckedChildren="Exclude"
              checked={isCheckedCOPU}
              onChange={setISCheckedCOPU}
            />
          </div>
        )}
        <Radio.Group
          onChange={e => setFileFormat(e.target.value)}
          value={fileFormat}
          buttonStyle="solid"
        >
          <Radio disabled={!showCreateButton} value="TWO">
            Create Separate 05 07 File(NERC Format)
          </Radio>
          <Radio disabled={!showCreateButton} value="ONE">
            Create Single 05 07 File(ISO Format)
          </Radio>
        </Radio.Group>

        <Button
          type="primary"
          onClick={onCreateFile}
          disabled={!showCreateButton}
          loading={spinning}
          icon="file-add"
          className="createFile"
        >
          Create File
        </Button>
        <Button
          type="primary"
          onClick={onCreateFile}
          disabled={showCreateButton}
          loading={spinning}
          icon="caret-right"
          className="continue"
        >
          Continue
        </Button>
        <Button
          disabled={showCreateButton}
          loading={spinning}
          type="danger"
          onClick={_ => {
            setData([])
            setShowCreateButton(true)
          }}
          icon="stop"
          className="abort"
        >
          Abort
        </Button>
      </CriteriaRow>
      <CriteriaRow style={{ padding: '0px 00px 10px 20px' }}>
        Some Units have Warnings/Errors. Please review the data in the grid and
        press Continue to create the file anyway or press Abort to cancel file
        creation
      </CriteriaRow>
      <FullHeightSizer heightOffset={400}>
        {({ height, width }) => {
          // return data && data.length > 0 ? (
          return (
            <Content style={{ height: height + 20 }}>
              {/* <Tabs
                  defaultActiveKey="carderror"
                  size="large"
                  tabBarExtraContent={
                    <div style={{ marginRight: '50px' }}>
                      <Input.Search
                        placeholder="Filter"
                        value={fuzzyFilter}
                        css={{ marginLeft: '10px', marginRight: '20px', flex: '0 0 200px' }}
                        onChange={e => setFuzzyFilter({ fuzzyFilter: e.target.value })}
                      />
                    </div>
                  }
                  height={height}
                >
                  <TabPane
                    tab="Errors"
                    key="carderror"
                    forceRender
                    style={{ height }}
                    tabBarStyle={{ marginBottom: '5px' }}
                  > */}
              <Grid
                sortEnabled
                data={data}
                headers={headerWithFormatter}
                altBgColor="#ebebeb"
                render={virtualizedGridRenderer({
                  autoFixColByKey: true,
                  rowHeaderRender,
                  height: height,
                  width: width - 50,
                  headerRowHeight: 30,
                })}
                sortOptions={[
                  { ident: 'utility', display: 'Utility', sortOrder: 'asc' },
                  { ident: 'unitId', display: 'Unit', sortOrder: 'asc' },
                ]}
                fuzzyFilter={fuzzyFilter}
              />
            </Content>
          )
        }}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  utility: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  apiTargetInfo: getApiTargetInfo(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(NercFileCreationAntd)

// const Nerccard95Headers = [
//   utilityHeader,
//   unitHeader,
//   numCol({ ident: 'year', display: 'Year', isKey: true }),
//   numCol({ ident: 'month', display: 'Month', isKey: true }),
//   strCol({ ident: 'revcode', display: 'Revcode', isFiltered: true }),
//   numCol({ ident: 'grossmaxcap', display: 'Grossmaxcap', isFiltered: true }),
//   numCol({ ident: 'grossdepcap', display: 'Grossdepcap', isFiltered: true }),
//   numCol({ ident: 'grossactgen', display: 'Grossactgen', isFiltered: true }),
//   numCol({ ident: 'netmaxcap', display: 'Netmaxcap', isFiltered: true }),
//   numCol({ ident: 'netdepcap', display: 'Netdepcap', isFiltered: true }),
//   numCol({ ident: 'netactgen', display: 'Netactgen', isFiltered: true }),
//   numCol({ ident: 'loadchar', display: 'Loadchar', isFiltered: true }),
//   numCol({ ident: 'attstart', display: 'Attstart', isFiltered: true }),
//   numCol({ ident: 'actualstart', display: 'Actualstart', isFiltered: true }),
//   strCol({ ident: 'loaddesc', display: 'Loaddesc', isFiltered: true }),
//   numCol({ ident: 'servhour', display: 'Servhour', isFiltered: true }),
//   numCol({ ident: 'reshour', display: 'Reshour', isFiltered: true }),
//   numCol({ ident: 'pumphour', display: 'Pumphour', isFiltered: true }),
//   numCol({ ident: 'synchour', display: 'Synchour', isFiltered: true }),
//   numCol({ ident: 'availhour', display: 'Availhour', isFiltered: true }),
//   numCol({ ident: 'poh', display: 'Poh', isFiltered: true }),
//   numCol({ ident: 'foh', display: 'Foh', isFiltered: true }),
//   numCol({ ident: 'moh', display: 'Moh', isFiltered: true }),
//   numCol({ ident: 'seh', display: 'Seh', isFiltered: true }),
//   numCol({ ident: 'unavailhour', display: 'Unavailhour', isFiltered: true }),
//   numCol({ ident: 'ph', display: 'Ph', isFiltered: true }),
//   numCol({ ident: 'inactive', display: 'Inactive', isFiltered: true }),
//   strCol({ ident: 'pfuel', display: 'Pfuel', isFiltered: true }),
//   numCol({ ident: 'pburned', display: 'Pburned', isFiltered: true }),
//   numCol({ ident: 'pavgheat', display: 'Pavgheat', isFiltered: true }),
//   numCol({ ident: 'pash', display: 'Pash', isFiltered: true }),
//   numCol({ ident: 'pmoist', display: 'Pmoist', isFiltered: true }),
//   numCol({ ident: 'psulfur', display: 'Psulfur', isFiltered: true }),
//   strCol({ ident: 'sfuel', display: 'Sfuel', isFiltered: true }),
//   numCol({ ident: 'sburned', display: 'Sburned', isFiltered: true }),
//   numCol({ ident: 'savgheat', display: 'Savgheat', isFiltered: true }),
//   numCol({ ident: 'sash', display: 'Sash', isFiltered: true }),
//   numCol({ ident: 'smoist', display: 'Smoist', isFiltered: true }),
//   numCol({ ident: 'ssulfur', display: 'Ssulfur', isFiltered: true }),
//   strCol({ ident: 'tfuel', display: 'Tfuel', isFiltered: true }),
//   numCol({ ident: 'tburned', display: 'Tburned', isFiltered: true }),
//   numCol({ ident: 'tavgheat', display: 'Tavgheat', isFiltered: true }),
//   numCol({ ident: 'tash', display: 'Tash', isFiltered: true }),
//   numCol({ ident: 'tmoist', display: 'Tmoist', isFiltered: true }),
//   numCol({ ident: 'tsulfur', display: 'Tsulfur', isFiltered: true }),
//   strCol({ ident: 'qfuel', display: 'Qfuel', isFiltered: true }),
//   numCol({ ident: 'qburned', display: 'Qburned', isFiltered: true }),
//   numCol({ ident: 'qavgheat', display: 'Qavgheat', isFiltered: true }),
//   numCol({ ident: 'qash', display: 'Qash', isFiltered: true }),
//   numCol({ ident: 'qmoist', display: 'Qmoist', isFiltered: true }),
//   numCol({ ident: 'qsulfur', display: 'Qsulfur', isFiltered: true }),
//   strCol({ ident: 'deleted', display: 'Deleted', isFiltered: true }),
// ]
